// «Cómo lo usan» (admin F3, 24-oct-2026): señales de uso por lote de negocios para el popover «Uso»
// de Negocios y Suscripciones y la tarjeta de la ficha. Backend: GET /api/admin/uso-negocios?ids=…
// (lib/usoNegocios.js). Solo lectura. Las reglas de medición (salida real, no interruptores; unión
// de fuentes para el último rastro; importado ≠ uso) viven en el backend; aquí solo se pinta.
import { baseApi } from './baseClient';

export interface UsoPlan {
  code: string; pago: boolean; trial: boolean; status: string | null; days_left: number | null;
  payment_method: string | null; autopay: boolean;
}
export interface UsoLealtad {
  clientes: number; clientes_nuevos_30d: number;
  visitas_30d: number; visitas_auto_30d: number; canjes_30d: number; ajustes_mano_30d: number;
  cumple_60d: number; campanas_60d: number;
  membresias: number; gift_cards: number; gift_cards_60d: number; etiquetas: number; sucursales: number; premios: number;
  tareas_60d: number; analiticas_60d: number; exportaciones_60d: number;
  whatsapp_propio: { estado: string | null; desde: string | null } | null;
}
export interface UsoAgenda {
  citas_creadas_30d: number; citas_propias_30d: number; importadas_30d: number; agendan: number;
  pasadas_30d: number; confirmadas_30d: number; asistencia_30d: number; canceladas_30d: number;
  cobros_30d: number; monto_30d: number; cotizaciones_30d: number; doctores: number;
  wa_30d: number; wa_ok_30d: number; analiticas_60d: number;
}
export interface UsoPos {
  available: boolean; error?: string;
  ventas_30d?: number; monto_30d?: number; dias_venta_30d?: number; ultimo_ticket?: string | null; cajeros_30d?: number;
  dispositivos?: number; dispositivos_vivos?: number; ultimo_visto?: string | null;
  turnos_abiertos?: number; turnos_30d?: number; usuarios_activos?: number;
}
export type RiesgoRenovacion = 'alto' | 'medio' | 'bajo' | 'nuevo';
export interface UsoNegocio {
  giro: 'lealtad' | 'dental' | 'spa' | 'letsmove' | 'clublectura' | 'bots' | string;
  vertical: string; brand: string | null; tiene_pos: boolean; demo: boolean;
  plan: UsoPlan; alta: string | null;
  acceso: { ultimo: string | null; ultima_sesion: string | null };
  personas: { altas: number; activas_30d: number; dias_30d: number };
  lealtad: UsoLealtad | null;
  agenda: UsoAgenda | null;
  gratis: { bloqueos_60d: Array<{ feature: string; n: number }>; analiticas_60d: number } | null;
  pos: UsoPos | null;
  automatico: { cumple: boolean; campanas: boolean; avisos_cita: boolean; algo: boolean };
  renovacion: { riesgo: RiesgoRenovacion; motivos: string[]; dias_alta?: number } | null;
}
export interface UsoRespuesta { generated_at: string; tenants: Record<string, UsoNegocio> }

export const adminUsoApi = {
  lote: (ids: Array<number | string>) =>
    baseApi.get<UsoRespuesta>(`/admin/uso-negocios?ids=${encodeURIComponent(ids.map(String).join(','))}`),
};
